// The trusted outer document owns the CSP. Its frame-src also blocks the
// artifact's own navigations, which a CSP inside the artifact cannot prevent.
const HTML_PREVIEW_CSP = [
   "default-src 'none'",
   "script-src 'unsafe-inline'",
   "style-src 'unsafe-inline'",
   "img-src data: blob:",
   "font-src data:",
   "media-src data: blob:",
   "connect-src 'none'",
   "frame-src blob:", // Only locally created documents; no HTTP(S) navigations.
   "base-uri 'none'",
   "form-action 'none'",
].join("; ");

export const htmlPreviewSandbox = (peek: boolean): string =>
   peek ? "allow-scripts" : "allow-scripts allow-downloads";

const escapeAttribute = (value: string): string =>
   value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

/** Keep untrusted HTML entirely inside a separately sandboxed child document. */
export const buildHtmlPreviewDocument = (html: string, title: string, peek: boolean): string => {
   // Escape '<' so artifact text cannot terminate the inert JSON script element.
   const payload = JSON.stringify(html).replace(/</g, "\\u003c");
   return `<!doctype html>
<html><head>
<meta http-equiv="Content-Security-Policy" content="${HTML_PREVIEW_CSP}">
<meta name="referrer" content="no-referrer">
<style>
html,body{margin:0;width:100%;height:100%;overflow:hidden}
iframe{display:block;width:100%;height:100%;border:0}
</style>
</head><body>
<iframe title="${escapeAttribute(title)}" sandbox="${htmlPreviewSandbox(peek)}" referrerpolicy="no-referrer"${peek ? ' tabindex="-1" aria-hidden="true"' : ""}></iframe>
<script type="application/json" id="artifact">${payload}</script>
<script>
const frame = document.querySelector('iframe');
const html = JSON.parse(document.getElementById('artifact').textContent);
const url = URL.createObjectURL(new Blob([html], {type: 'text/html'}));
frame.onload = () => URL.revokeObjectURL(url);
frame.src = url;
</script>
</body></html>`;
};
